import { QueryStatus, QueryStatusType } from 'src/types'
import { Accion } from '../types'
import { useEffect, useState } from 'react'
import { HttpSistema } from '../api/httpSistema'

type UseAccionResult = {
    status: QueryStatusType
    acciones: Accion[] | undefined
}

export const useAcciones: (idEtapa: number) => UseAccionResult = idEtapa => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [acciones, setAcciones] = useState<Accion[]>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpSistema.getAcciones(idEtapa)
            .then(value => {
                setAcciones(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }, [idEtapa])

    return { acciones, status }
}
